
import { Users, Phone } from "lucide-react";

export const TrustBadges = () => {
  const badges = [
    {
      icon: Users,
      text: "150+ Customers",
      color: "text-purple-400"
    },
    {
      icon: Phone,
      text: "24/7 Support",
      color: "text-orange-400"
    }
  ];

  return (
    <div className="flex flex-wrap justify-center gap-6 mt-8 p-4 bg-white/5 rounded-lg">
      {badges.map((badge, index) => (
        <div key={index} className="flex items-center space-x-2">
          <badge.icon className={`h-5 w-5 ${badge.color}`} />
          <span className="text-sm text-gray-300">{badge.text}</span>
        </div>
      ))}
    </div>
  );
};
